import React, { useEffect, useState } from 'react';
import 'rc-banner-anim/assets/index.css';
import { Button, Col, Flex, Row } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const Content3 = (props) => {
  const { dataSource, isMobile, ...restProps } = props;
  const { t } = useTranslation();
  const { titleWrapper, page, childWrapper } = dataSource;

  return (
    <div {...restProps} {...dataSource.wrapper}>
      <div {...page}>
        <div key="content3">
          <div {...titleWrapper}>
            <h1 {...titleWrapper.children[0]}>
              {t(titleWrapper.children[0].children)}
            </h1>
            <h2 {...titleWrapper.children[1]}>
              {titleWrapper.children[1].children}
            </h2>
          </div>
          <Flex gap={'large'} {...childWrapper} vertical={isMobile}>
            {
              childWrapper.children.map((item, i) => {
                return (
                  <div key={i.toString()} {...item} style={{ width: isMobile ? '100%' : '32%' }}>
                    <img src={require('@/assets/production/test/' + item.children.img)} />
                    <h2>{t(item.children.title)}</h2>
                    <ul>
                      {
                        item.children.children.map((content, j) => {
                          return (
                            <li key={j.toString()}>
                              {/*<span>{content.title}</span>*/}
                              <span dangerouslySetInnerHTML={{ __html: t(content.children) }}></span>
                            </li>
                          );
                        })
                      }
                    </ul>
                  </div>
                );
              })
            }
          </Flex>
        </div>
      </div>
    </div>
  );
};

export default Content3;
